import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined';
import { useNavigate } from 'react-router-dom';
import brand from '../theme/brand';

interface ErrorScreenProps {
  title: string;
  message: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({
  title,
  message,
  buttonText = 'Go Back',
  onButtonClick,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: 4,
        backgroundColor: 'background.default',
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 80,
          height: 80,
          borderRadius: '26px',
          mb: 3,
          backgroundColor: theme.palette.mode === 'light' ? 'rgba(196, 125, 78, 0.12)' : 'rgba(212, 149, 106, 0.14)',
          color: brand.copper,
        }}
      >
        <SentimentDissatisfiedOutlinedIcon sx={{ fontSize: 40 }} />
      </Box>

      <Typography variant="h4" gutterBottom sx={{ color: 'primary.main' }}>
        {title}
      </Typography>

      <Typography
        variant="body1"
        align="center"
        color="text.secondary"
        sx={{ mb: 4, maxWidth: 440, lineHeight: 1.6 }}
      >
        {message}
      </Typography>

      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={handleButtonClick}
        sx={{
          borderRadius: 3,
          px: 4,
          py: 1.25,
          background: theme.palette.mode === 'light' ? brand.forestGradient : undefined,
        }}
      >
        {buttonText}
      </Button>
    </Box>
  );
};

export default ErrorScreen;
